// extracted by mini-css-extract-plugin
module.exports = {"asidex":"Courses_asidex__IX5iT"};